<template lang="pug">
  #StoresManager
    appHeader(
      :hasBackTool="true",
      targetRouterName="sm-items-list-index"
    )
    router-view.content-body-hasFooter
    appSmFooter
</template>

<script>
import appHeader from '@/components/partials/AppHeader.vue';
import appSmFooter from '@/components/partials/AppSmFooter.vue';

export default {
  // 不管這邊打大小寫 顯示都會是以大寫形式為主
  name: 'StoresManagerComponent',
  components: {
    appHeader,
    appSmFooter
  }
};
</script>
